jQuery(document).ready(function(){
	jQuery('.wp-block-ic-blocks-map').each(function(){
		let currentContainer = jQuery(this).find('>.ic-blocks-map-container');
		let currentMarkers = jQuery(this).find('>.wp-block-ic-blocks-marker');
		let isCluster = currentContainer.data('is-cluster');
		let currentLeafLetMap = new L.map(currentContainer[0],{
			scrollWheelZoom: true,
			maxZoom: 20
		});

		let markers = [];
		let cluster = L.markerClusterGroup();

		currentMarkers.each(function(){
			let currentMarker = jQuery(this);

			let lat = currentMarker.data("lat");
			let lng = currentMarker.data("lng");
			let iconUrl = currentMarker.data("icon-url");
			let iconSizeX = currentMarker.data("icon-size-x");
			let iconSizeY = currentMarker.data("icon-size-y");
			let iconAnchorX = currentMarker.data("icon-anchor-x");
			let iconAnchorY = currentMarker.data("icon-anchor-y");

			markers.push([lat, lng]);

			let markerIcon = L.icon({
				iconUrl: 	  iconUrl ? iconUrl : '/wp-content/plugins/ic-blocks/assets/img/marker.png',
				iconSize:     [iconSizeX, iconSizeY],
				iconAnchor:   [iconAnchorX, iconAnchorY],
			});

			let coord = [currentMarker.data('lat'), currentMarker.data('lng')];
			let marker = L.marker(coord,{icon:markerIcon});
			if(isCluster) cluster.addLayer(marker);
			marker.addTo(currentLeafLetMap);

			if(currentMarker.text().length>2) marker.bindPopup(currentMarker.html());
			currentMarker.remove();
		})
		if(isCluster) currentLeafLetMap.addLayer(cluster);

		currentLeafLetMap.fitBounds(markers);
		currentLeafLetMap.setZoom(parseInt(currentContainer.data('zoom')));
		L.tileLayer(currentContainer.data('tile'), "").addTo(currentLeafLetMap);

		let southWest = L.latLng(-89.98155760646617, -180),
			northEast = L.latLng(89.99346179538875, 180);
		let bounds = L.latLngBounds(southWest, northEast);

		currentLeafLetMap.setMaxBounds(bounds);
		currentLeafLetMap.on('drag', function() {
			currentLeafLetMap.panInsideBounds(bounds, { animate: false });
		});
	})
})
